module.exports = __webpack_public_path__ + "images/patterns/light/BrickHorizontal.609865416b429fdb8d15.svg";